import axios, {AxiosRequestConfig} from 'axios';
import Repository from '@/services/Repository';
import InvalidResponse from '@/exceptions/InvalidResponse';

export default class Api {

    private static isDevelopmentEnvironment(): boolean {
        return window.location.hostname === 'localhost';
    }

    private repository: Repository;

    private baseUrlDevelopment: string = 'http://localhost:4080/';
    private baseUrlProduction: string = 'https://api.finance.coloroboros.com/';

    constructor(repository: Repository) {
        this.repository = repository;
    }

    public async signIn(email: string, password: string): Promise<void> {
        const token = await this.post('auth', {email, password});
        if (typeof token !== 'string') {
            throw new InvalidResponse(token);
        }
        this.repository.token = token;
    }

    public async getAclAccounts(): Promise<[]> {
        return await this.get('acl/accounts');
    }

    public async deleteAclAccount(id: string): Promise<void> {
        await this.delete('acl/accounts', id);
    }

    private async post(method: string, data: {}): Promise<any> {
        const result = await axios.post(this.prepareFullUrl(method), data, this.prepareConfigWithContentType(method));
        return result.data.data;
    }

    private async get(method: string): Promise<any> {
        const result = await axios.get(this.prepareFullUrl(method), this.prepareConfig(method));
        return result.data.data;
    }

    private async delete(method: string, id: string): Promise<void> {
        await axios.delete(this.prepareFullUrl(method, id), this.prepareConfigWithContentType(method));
    }

    private prepareFullUrl(method: string, id?: string): string {
        const baseUrl = Api.isDevelopmentEnvironment()
            ? this.baseUrlDevelopment
            : this.baseUrlProduction;
        const idPostfix = id !== undefined ? `/${id}` : '';
        return `${baseUrl}${method}${idPostfix}`;
    }

    private prepareConfigWithContentType(method: string): AxiosRequestConfig {
        const config: AxiosRequestConfig = this.prepareConfig(method);
        config.headers['Content-Type'] = 'application/json';
        return config;
    }

    private prepareConfig(method: string): AxiosRequestConfig {
        const config: AxiosRequestConfig = {
            headers: {
                'Accept': 'application/json',
                'Version': 2,
                'Content-Type': 'application/json',
            },
        };
        if (!['auth'].includes(method)) {
            config.headers.Authorization = 'Bearer ' + this.repository.token;
        }
        return config;
    }
}